import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {InvoiceEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconDownload} from "@tabler/icons-react";

export type InvoiceAction = "DOWNLOAD"

export type InvoiceActionMenuDropdownProps = {
  invoice: InvoiceEntity
  onActionClick?: (action: InvoiceAction) => void
}

export const InvoiceActionMenuDropdown = (props: InvoiceActionMenuDropdownProps) => {
  const {invoice, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<InvoiceAction> = useMemo(() => {
    const actions = new Set<InvoiceAction>()
    if (hasAccess("invoice_view")) {
      actions.add("DOWNLOAD")
    }
    return actions
  }, [invoice, hasAccess])

  const _onActionClick = useCallback((action: InvoiceAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("DOWNLOAD") &&
        <Menu.Item
          onClick={() => _onActionClick("DOWNLOAD")}
          icon={<IconDownload size={14}/>}>
          {t("common.action.download", "Download")}
        </Menu.Item>
      }
    </>
  )
}
